<template>
    <div>
        <c-search-form :input-search-items="searchItems" :rows-per-page-items="[10,20,50]"
                       :input-create-items="createItems"
                       :form-name="formName" model="searchForm" :fields="fields"
                       search-url="/fullTextSearch/searchTable" accept-create="false" accept-delete="false" @search="updateSchema">
            <v-btn color="purple" dark @click="showSchema" slot="feartureBtn">
                <v-icon dark left>visibility</v-icon>
                {{$t('lang.search.schema')}}
            </v-btn>
            <v-btn color="red" dark @click="indexingAll" slot="feartureBtn">
                <v-icon dark left>build</v-icon>
                {{$t('lang.search.index_all')}}
            </v-btn>
            <v-btn color="blue" dark @click="showUpload" slot="feartureBtn">
                <v-icon dark left>cloud_upload</v-icon>
                {{$t('lang.search.upload_index')}}
            </v-btn>
            <template slot="viewColumn" slot-scope="data" v-item="data">
                <div style="text-align: center">
                    <v-btn depressed outline icon fab dark color="primary" small @click="viewColumn(data.item)">
                        <v-icon>list</v-icon>
                    </v-btn>
                </div>
            </template>
            <template slot="Indexing" slot-scope="data" v-item="data">
                <div style="text-align: center">
                    <v-btn depressed outline icon fab dark color="primary" small @click="indexingItem(data.item)">
                        <v-icon>build</v-icon>
                    </v-btn>
                </div>
            </template>
            <div id="sqlDesign" slot="extra_component" style="display: none">
            </div>
        </c-search-form>
        <column-dlg></column-dlg>
        <upload-dlg></upload-dlg>
    </div>
</template>

<script>
    import CSearchForm from "../../../components/form/ManageForm";
    import VueController from "../../../../public/js/controller";
    import axios from "axios";
    import ColumnDlg from "./ColumnDlg";
    import designSQL from '../../../../public/plugin/queryBuilder/design.css';
    import DesignEnvironment from '../../../../public/plugin/queryBuilder/sqldesign.js';
    import UploadDlg from "./UploadDlg";

    export default {
        name: 'form-management',
        components: {UploadDlg, ColumnDlg, CSearchForm},
        data: () => {
            return {
                formName: "lang.search.index_title",
                searchItems: [
                    {
                        type: "text",
                        name: "tableName",
                        label: "lang.search.tablename",
                        placeHolder: "",
                        focus:true
                    },
                    {
                        type: "text",
                        name: "columnName",
                        label: "lang.search.columnname",
                        placeHolder: "",
                    }
                ],
                fields: [
                    {value: "index", text: "lang.common.index", sortable: false, width: "10%", headerStyle:"text-align:center"},
                    {value: "checkbox", text: "Select Table", type: "checkbox", sortable: false, width: "10%"},
                    {value: 'tableName', text: 'lang.search.tablename', sortable: false, width: "60%", headerStyle:"text-align:left"},
                    {
                        value: 'viewColumn',
                        text: "lang.search.view_column",
                        icon: "list",
                        method: "viewColumn",
                        sortable: false,
                        compound: true,
                        width: "20%",
                        headerStyle:"text-align:center"
                    },
                    {
                        value: 'Indexing',
                        text: "lang.search.index_table",
                        icon: "build",
                        method: "Indexing",
                        sortable: false,
                        compound: true,
                        width: "20%",
                        headerStyle:"text-align:center"
                    }
                ]
            }
        },
        methods: {
            indexingAll: function () {
                let search = VueController.getComponentByComponentName("c-search-form");
                let items = search.items;
                //console.log(items);
                let indexItems = [];
                for (let i = 0; i < items.length; i++) {
                    if (items[i].check == true) {
                        indexItems.push(items[i]);
                    }
                }
                //console.log(indexItems);
                if (indexItems.length == 0) {
                    alert("please select at least one table");
                } else {
                    this.indexing(indexItems);
                }
            },

            indexingItem: function (data) {
                //console.log(data);
                this.indexing([data]);
            },

            validateIndexing:function(tables){
                for(let i=0;i<tables.length;i++){
                    let table = tables[i];
                    let hasTitle = false;
                    let hasContent = false;
                    //console.log(tables[i]);
                    for(let j=0;j<tables[i].lstColumn.length;j++){
                        if(tables[i].lstColumn[j].comment != null) {
                            //console.log(tables[i].lstColumn[j].comment);
                        }
                        if(tables[i].lstColumn[j].comment == "title"){
                            hasTitle = true;
                        } else if(tables[i].lstColumn[j].comment == "content"){
                            hasContent = true;
                        }
                    }
                    if(!hasTitle){
                        alert("please select title column for table: '"+ table.tableName +"' before index");
                        return false;
                    }
                    if(!hasContent){
                        alert("please select content column for table: '"+ table.tableName +"' before index");
                        return false;
                    }
                }
                return true;
            },

            indexing: function (tables) {
                if(!this.validateIndexing(tables)){
                    return;
                }
                axios.post(process.env.VUE_APP_API_URL + "/fullTextSearch/indexing", tables).then(
                    data => {
                        alert("Index success");
                    },
                    error => {
                        alert("Index failed");

                    });

            },

            viewColumn: function (table) {
                let columnDlg = VueController.getComponentByComponentName("column-dlg");
                columnDlg.items = table.lstColumn;
                columnDlg.onShow(true);
            },

            updateSchema:function(){
                let search = VueController.getComponentByComponentName("c-search-form");
                let items = search.items;
                //console.log(items);
                let ob = DesignEnvironment.design("sqlDesign", items, false);
                document.getElementById(DesignEnvironment.tableDesignId).style.display="none";
                document.getElementById("sqlDesignDesign").style="height:600px !important";
                for (let i = 0; i < items.length; i++) {
                    ob.addTable(items[i].tableName);
                }
            },

            showSchema: function(){
                if(document.getElementById("resultTable").style.display=="none"){
                    document.getElementById("resultTable").style.display="";
                    document.getElementById("sqlDesign").style.display = "none";
                } else {
                    document.getElementById("sqlDesign").style.display = "";
                    document.getElementById("resultTable").style.display = "none";
                    this.updateSchema();
                }
            },

            showUpload: function(){
                let upload = VueController.getComponentByComponentName("upload-dlg");
                upload.show = true;
            }

        }
    }
</script>
